import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-view-package-medicao',
  templateUrl: './view-package-medicao.component.html',
  styleUrls: ['./view-package-medicao.component.css']
})
export class ViewPackageMedicaoComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ViewPackageMedicaoComponent>
  ) { }

  services = new Array();
  products = new Array();

  ngOnInit(): void {
    if (this.data.package.is_custom) {
      const customPackage = this.data.medicao.contract.budget.package_custom
        .find((pkg) => pkg.package_id == this.data.package.package_id);

      if (customPackage) {
        this.products = customPackage.custom_product;
        this.services = customPackage.custom_service;
      }
    } else {
      this.products = this.data.package.package.ml_packages_product;
      this.services = this.data.package.package.ml_packages_services;
    }
  }

}
